/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Option, SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { ViewMap } from '@constants/viewOptions';
import { ViewValues } from '@g17eco/types/surveyOverview';
import { CustomMetricContext } from '../CustomMetricContainer';
import { QUESTION } from '@constants/terminology';

const getViewOptions = () => {
  return [ViewValues.Custom, ViewValues.AssignedMetrics].map((k: ViewValues) => ViewMap[k]);
};

export const ViewQuestionsDropdown = () => {
  const { groupBy, setGroupBy } = React.useContext(CustomMetricContext);

  const onChange = (selectedOption: Option | null) =>
    setGroupBy(selectedOption?.value as ViewValues);
  const options = getViewOptions();
  const value = options.find((o) => o.value === groupBy);

  return (
    <SelectFactory
      selectType={SelectTypes.SingleSelect}
      placeholder={`Select View ${QUESTION.CAPITALIZED_PLURAL} By`}
      options={options}
      value={value}
      onChange={onChange}
      isSearchable={false}
      backgroundColor={'var(--theme-BgExtralight)'}
    />
  );
};
